import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = false

// Import CSS framework Buefy
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
Vue.use(Buefy)

import AOS from 'aos'
AOS.init({
  duration: 500
})

// Import Apex Charts
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

// Import Vuex store
import store from '@/store/store'

// Import pages
import Home from '@/pages/Home'

// Import router
import VueRouter from 'vue-router'
Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    component: Home,
    name: "home"
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
